import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle, branch, renderComponent } from 'recompose'

import {
  assistantAgentSettings,
  editingAssistantAgentSettings,
  fetchAssistantOrgSettingsPending,
  assistantConfigHasEdits,
  personalizationTags,
  sendTestEmailPending
} from 'app/modules/assistantSettings/selectors'
import * as AssistantSettingsActions from 'app/modules/assistantSettings/actions'
import { Loader } from '@driftt/tide-core-legacy'

const mapStateToProps = (state) => ({
  assistantAgentSettings: assistantAgentSettings(state),
  fetchAssistantOrgSettingsPending: fetchAssistantOrgSettingsPending(state),
  editingAssistantAgentSettings: editingAssistantAgentSettings(state),
  assistantConfigHasEdits: assistantConfigHasEdits(state),
  personalizationTags: personalizationTags(state),
  sendTestEmailPending: sendTestEmailPending(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAssistantAgentSettings: AssistantSettingsActions.fetchAssistantAgentSettings,
      patchAssistantAgentSettings: AssistantSettingsActions.patchAssistantAgentSettings,
      setInitial: AssistantSettingsActions.setInitial,
      onUpdate: AssistantSettingsActions.onUpdate,
      onCancel: AssistantSettingsActions.onCancel,
      sendTestEmail: AssistantSettingsActions.sendTestEmail,
      fetchPersonalizationTags: AssistantSettingsActions.fetchPersonalizationTags,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const { actions } = this.props
      actions.fetchAssistantAgentSettings()
      actions.fetchPersonalizationTags()
    },
  }),
  withHandlers({
    onSave: ({ actions, editingAssistantAgentSettings }) => () => {
      return actions.patchAssistantAgentSettings({ settings: editingAssistantAgentSettings })
    },
    onCancel: ({ actions, assistantAgentSettings }) => () => {
      return actions.onCancel(assistantAgentSettings)
    },
  }),
  branch(({ fetchAssistantOrgSettingsPending }) => fetchAssistantOrgSettingsPending, renderComponent(Loader))
)



// WEBPACK FOOTER //
// ./src/scripts/components/EmailTemplateModal/EnhanceWithAssistantConfig.js